import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import styles from './UserPanelBadge.module.css';

export enum UserBadgeVariants {
  primary = 'primary',
  orange = 'orange',
  green = 'green',
  blue = 'blue',
}

interface UserPanelBadgeProps {
  content?: string | null;
  color?: UserBadgeVariants;
}

const UserPanelBadge: FC<UserPanelBadgeProps> = ({ content, color = UserBadgeVariants.primary }) => {
  if (content === null || content === undefined) {
    return null;
  }

  return (
    <div
      className={twMerge(
        styles.badge,
        color === UserBadgeVariants.primary
          ? 'border-ph-primary-violet bg-ph-violet-medium text-ph-primary-violet'
          : '',
        color === UserBadgeVariants.orange ? styles.orange : '',
        color === UserBadgeVariants.green ? styles.green : '',
        color === UserBadgeVariants.blue ? styles.blue : '',
      )}
    >
      <span className={twMerge(styles.textWrapper, 'relative w-fit text-center text-sm leading-none tracking-[0]')}>
        {content}
      </span>
    </div>
  );
};

export default UserPanelBadge;
